import React from 'react';
import { useNavigate } from 'react-router-dom';
import { T } from '../theme';
import { useLookups } from '../usePm';

export default function Brands() {
  const { brands } = useLookups();
  const nav = useNavigate();
  return (
    <div>
      <h1 style={{ color: T.text, fontSize: 24, margin: '0 0 4px' }}>Markalar</h1>
      <div style={{ color: T.muted, fontSize: 14, marginBottom: 22 }}>{brands.length} marka</div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 14 }}>
        {brands.map(b => (
          <div key={b.id} onClick={() => nav(`/brands/${b.id}`)} style={{
            background: T.card, border: `1px solid ${T.border}`, borderRadius: 12, padding: 18, cursor: 'pointer',
          }}
            onMouseEnter={e => e.currentTarget.style.borderColor = T.blue}
            onMouseLeave={e => e.currentTarget.style.borderColor = T.border}>
            <div style={{ color: T.text, fontSize: 16, fontWeight: 700 }}>{b.brand_name || b.company_name}</div>
            {b.brand_name && b.company_name && b.brand_name !== b.company_name && (
              <div style={{ color: T.dim, fontSize: 12, marginTop: 2 }}>{b.company_name}</div>
            )}
            <div style={{ marginTop: 12, display: 'flex', gap: 6, alignItems: 'center' }}>
              <span style={{ background: T.blue + '22', color: T.blue, fontSize: 12, fontWeight: 600, padding: '3px 10px', borderRadius: 20 }}>{b.open_tasks} açık görev</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
